// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1654339084568
      var cssReload = require("C:/Users/antoi/Desktop/Site-ID-2022/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  